module.exports = __webpack_public_path__ + "f41c9b18f5f3691b6a64027be3efc55f.png";